import React from 'react';

import PropTypes from 'prop-types';
import Select from '@tds/core-select';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByFlag = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByFlag, flagPlaceholder, messagesFlagFilters }
  } = localizedStrings;
  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-flag' }}>
      <Select
        label={filterByFlag}
        placeholder={flagPlaceholder}
        options={messagesFlagFilters}
        defaultValue=""
        value={filters.flag}
        onChange={e => setFilters({ ...filters, flag: e.target.value })}
      />
    </div>
  );
};

FilterByFlag.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByFlag;
